export const selectTenantId = (state) => {
    const tenants = state.selectedOwners;
    return tenants[0];
};
//# sourceMappingURL=selectors.js.map